// extracted by mini-css-extract-plugin
export default {"wrapper":"Markdown_wrapper__NjrdV"};